export const consLogged = {
    INICIANDO: 'iniciando',
    LOGGED: 'logged',
    NOTLOGGED: 'not logged'
}